import Towngas from "../images/casesPage/towngas.png";

const painterCases = [
    {
        location: "Towngas",
        image: Towngas
    }
];

export default painterCases;